import React from 'react';
import { clsx } from 'clsx';
import styles from './Divider.module.css';

type DividerProps = React.HTMLAttributes<HTMLHRElement> & {
	/**
	 * Optional CSS class name for styling the component.
	 */
	className?: string;
	/**
	 * Indicates the type of divider
	 * @default solid-light-gray
	 */
	variant?: 'solid-light-gray' | 'solid' | 'dashed-light-gray' | 'dashed' | 'dotted';
	/**
	 * Indicates whether the divider is in a vertical or horizontal position
	 * @default false
	 */
	vertical?: boolean;
};

export const Divider = React.forwardRef<HTMLHRElement, DividerProps>(
	({ className, vertical = false, variant = 'solid-light-gray', ...props }, ref) => {
		return (
			<hr
				ref={ref}
				aria-orientation={vertical ? 'vertical' : 'horizontal'}
				className={clsx(styles.divider, styles[variant], { [styles.vertical]: vertical }, className)}
				{...props}
			></hr>
		);
	}
);
Divider.displayName = 'DividerDigital';
